import { Badge, BlockStack, InlineStack, Text } from '@shopify/polaris';
import { getNiceDate } from '../../../shared/components/events/eventTimeLine';

const LABELS = {
  APPROVAL_ASSIGNED: ['Assigned', 'info'],
  APPROVAL_REASSIGNED: ['Reassigned', 'info'],
  APPROVAL_ALLOCATION_SAVED: ['Split saved', undefined],
  APPROVAL_APPROVED: ['Approved', 'success'],
  APPROVAL_REJECTED: ['Rejected', 'critical'],
  APPROVAL_REOPENED: ['Reopened', 'warning'],
  APPROVAL_STATUS_CHANGED: ['Status', undefined],
  PURCHASE_ORDER_LINKED: ['PO linked', 'info'],
  PURCHASE_ORDER_UNLINKED: ['PO unlinked', 'warning'],
  INTAKE_ENRICHED: ['Analysed', undefined],
  PAYMENT_APPROVAL_WARNING: ['Paid while not approved', 'critical']
};

function detail(event) {
  const data = event.data || {};
  switch (event.type) {
    case 'APPROVAL_ASSIGNED':
      return `to ${data.assigneeAfkorting || data.assigneeId}${data.approveNow ? ' (approved directly)' : ''}${data.note ? ` · ${data.note}` : ''}`;
    case 'APPROVAL_REASSIGNED':
      return `${data.handOff ? 'part handed' : 'handed'} to ${data.toAfkorting || (data.toUserIds || [data.toUserId]).join(', ')}${data.note ? ` · ${data.note}` : ''}`;
    case 'APPROVAL_REJECTED':
      return data.reason || '';
    case 'APPROVAL_STATUS_CHANGED':
      return `${data.from || '-'} → ${data.to}`;
    case 'PURCHASE_ORDER_LINKED':
    case 'PURCHASE_ORDER_UNLINKED':
      return `PO ${data.purchaseOrderNumber || data.purchaseOrderId}${data.source ? ` (${data.source})` : ''}`;
    case 'INTAKE_ENRICHED':
      return `${data.textSource || 'no text'}${data.autoLinked?.length ? ` · linked ${data.autoLinked.join(', ')}` : ''}`;
    case 'PAYMENT_APPROVAL_WARNING':
      return `via ${data.via}, status ${data.approvalStatus || 'unknown'}`;
    case 'APPROVAL_APPROVED':
      return `${data.lineIds?.length || 1} line(s)${data.note ? ` · ${data.note}` : ''}`;
    default:
      return '';
  }
}

// Compact approval history built from the events in the card payload (no extra request).
export default function ApprovalTimeline({ events = [] }) {
  if (!events.length) {
    return (
      <Text variant="bodySm" tone="subdued">
        No approval history yet.
      </Text>
    );
  }
  return (
    <BlockStack gap="100">
      {events.map((event, index) => {
        const [label, tone] = LABELS[event.type] || [event.type, undefined];
        return (
          <InlineStack key={`${event.timestamp}-${index}`} gap="200" blockAlign="center" wrap={false}>
            <Badge tone={tone} size="small">
              {label}
            </Badge>
            <Text variant="bodySm">{event.userAfkorting || (event.userId ? `#${event.userId}` : 'system')}</Text>
            <Text variant="bodySm" tone="subdued">
              {getNiceDate(Number(event.timestamp))}
            </Text>
            <Text variant="bodySm" tone="subdued" truncate>
              {detail(event)}
            </Text>
          </InlineStack>
        );
      })}
    </BlockStack>
  );
}
